export const WEB_URL = 'http://comparemyreligion.com/MagzentineServices/';
// export const WEB_URL = 'http://localhost/compare-my-religion/MagzentineServices/';
// export const WEB_URL = 'http://192.168.1.133/compare-my-religion/MagzentineServices/';

export const IMAGE_WEB_URL = 'http://magzentine.com/dev.magzentine.com/';



// WEBPACK FOOTER //
// ./src/app/pages/masterconstants.ts